/**
 * @file client.js
 * @location src/integrations/supabase/client.js
 * @role Supabase 클라이언트 싱글톤 — 인증·DB·Realtime 진입점
 *
 * 환경변수: VITE_SUPABASE_URL · VITE_SUPABASE_ANON_KEY (.env.local).
 * 미설정 시 throw — 백엔드 없이 부팅하면 조기에 명확히 실패하게 한다.
 *
 * ⚠️ useAppStore.js 외부에서 직접 localStorage 접근 금지 규칙의 예외:
 *    Supabase 세션 토큰 저장은 라이브러리가 관리(persistSession). 우리 도메인 상태 아님.
 */
import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    '[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY 가 없습니다. .env.local 을 확인하세요 (.env.example 참고).',
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,   // 매직링크 콜백(#access_token=...) 자동 처리
    flowType: 'pkce',
  },
});
